import { render } from "./ThreeD.vue?vue&type=template&id=45b971e3&scoped=true"
import script from "./ThreeD.vue?vue&type=script&lang=js"
export * from "./ThreeD.vue?vue&type=script&lang=js"

import "./ThreeD.vue?vue&type=style&index=0&id=45b971e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b971e3"]])

export default __exports__